export default "__VITE_ASSET__SjkYcdek__"